<template>
  <div class="wg-row world-sub-menu-component" :style="'height:' + componentHeight">
    <!-- Menu -->
    <div class="wg-col wg-xs-12 wg-sm-3 wg-lg-2 sub-menu-col" :style="menuStyle">
      <!-- Mobile - Topbar -->
      <template v-if="mode === 'topbar' && windowWidth <= 767">
        <div class="wg-row topbar-list-menu">
          <div
              v-for="(item, index) in list"
              :key="'header-'+index" 
              :style="{width: (100 / list.length) + '%'}"
              :class="['wg-row', 'item', !isActive(item.id) || disabled ? 'inactive' : '']"
              :title="item.label"
              @click="!disabled && isActive(item.id) ? (item.link ? $router.push(item.link) : changePage(item)) : ''">
            <img :src="item.img" :class="[selected === item.id ? 'selected' : '']">
          </div>
        </div>
      </template>
      <!-- Mobile - Dropdown -->
      <template v-else>
        <div
          v-show="windowWidth <= 767"
          class="wg-row wg-xs-12 wg-sm-none dropdown-list-button"
          style="cursor:pointer;flex-wrap:nowrap;align-items:center;justify-content:space-between;"
          @click="menuOpen = !menuOpen;"
        >
          <div class="com-anm22-app-text-l">{{ label + ' - ' + itemSelected.label }}</div>
          <img
            :src="$anm22.icons.getWorldIcon(menuOpen ? 'arrowUp' : 'arrowDown')"
            class="com-anm22-app-img-fixed-height-m"
            style="margin-left:5px;opacity:0.4;"
          >
        </div>
        <!-- Lista - viene usata solo in caso di dropdown/schermo largo -->
        <div v-show="windowWidth > 767 || menuOpen" class="wg-row sub-menu-list" style="padding:0 10px;">
          <nav class="wg-row sub-menu-nav">
            <ul v-if="Array.isArray(list)" class="sub-menu-ul">
              <li
                v-for="(item, index) in list"
                :key="'sub-'+index"
                class="wg-row sub-menu-li"
                :class="{ selected: selected === item.id, inactive: disabled || !isActive(item.id) }"
                @click="!disabled && isActive(item.id) ? (item.link ? $router.push(item.link) : changePage(item)) : ''"
              >
                <img
                  v-if="item.img !== ''"
                  :src="item.img"
                  class="item-icon"
                >
                <div
                  class="com-anm22-app-text-m"
                  :style="[selected === item.id ? {fontWeight: 'bold'} : {}]"
                >{{ item.label }}</div>
              </li>
            </ul>
            <ul v-else 
                v-for="(items, title, index) in list"
                :key="'sub-menu-cat-'+index"
                class="sub-menu-ul"
            >
              <div class="com-anm22-app-text-l title">{{ title }}</div>
              <li
                v-for="(item, index) in items"
                :key="'sub-'+index"
                class="wg-row sub-menu-li"
                :class="{ selected: selected === item.id, inactive: disabled || !isActive(item.id) }"
                @click="!disabled && isActive(item.id) ? (item.link ? $router.push(item.link) : changePage(item)) : ''"
              >
                <img
                  v-if="item.img !== ''"
                  :src="item.img"
                  class="item-icon"
                >
                <div
                  class="com-anm22-app-text-m"
                  :style="[selected === item.id ? {fontWeight: 'bold'} : {}]"
                >{{ item.label }}</div>
              </li>
            </ul>
          </nav>
        </div>
      </template>
    </div>
    <!-- Content -->
    <div 
        class="wg-col wg-xs-12 wg-sm-9 wg-lg-10 com-anm22-app-scrolling-panel"
        :style="{height: ( windowWidth <= 767 ? 'calc(100% - 47px)' : '100%')}">
      <div class="wg-row wg-p-xs-20" style="height:100%;">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    label: {
      type: String,
      default: "Menu"
    },
    mode: {
      type: String,
      default: "dropdown" //dropdown o topbar
    },
    list: {
      type: Array,
      default: () => []
    },
    restrictions: {
      type: Array,
      default: () => []
    },
    //Selezione di una opzione dall'esterno
    selected: [String, Number],
    /* Disabilitare cambio pagina */
    disabled: {
      type: Boolean,
      default: false
    },
    menuStyle: {
      type: Object,
      default: () => ({})
    },
    componentHeight: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return {
      menuOpen: false
    };
  },
  computed: {
    ...mapState({
      windowWidth: state => state.windowWidth
    }),
    itemSelected() {
      return this.list.find(i => i.id === this.selected) || {};
    }
  },
  methods: {
    changePage(item) {
      this.menuOpen = false;
      this.$emit("changePage", item);
    },
    isActive(id) {
      if (this.restrictions.length > 0) {
        return this.restrictions.includes(id);
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-menu-col {
  border-right:1px solid #eee;
  position:relative;
}
.sub-menu-nav {
}
.sub-menu-ul {
  width: 100%;
  padding: 0;
  .title {
    color: #999;
    font-weight: bold;
    text-transform: uppercase;
    padding: 7px 0;
  }
}
.sub-menu-li {
  box-sizing: border-box;
  padding: 2px 0 2px 0;
  min-height: 35px;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  border-radius: 4px;
  padding: 5px;
  margin: 1px;
  &.selected {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &:hover {
    border-radius: 2px;
    background-color: rgba(0, 0, 0, 0.05);
  }
  &.inactive {
    opacity: 0.3;
    pointer-events: none;
  }

  .item-icon {
    height: 20px !important;
    margin-right: 20px;
  }
  &>div {
    font-size: 14px;
    font-weight: 500;
  }
}
.dropdown-list-button {
  position: relative;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
@media (max-width: 767px) {
  .sub-menu-col {
    border: none;
  }
  .sub-menu-nav {
    padding: unset;
  }
  .sub-menu-ul {
    padding: 10px 0 0;
  }
  .sub-menu-list {
    position: absolute;
    background: #fff;
    z-index: 100;
    border: 1px solid #ccc;
    border-top: none;
  }
}
.topbar-list-menu {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-around;
  background-color: #eee;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
  font-size: 18px;
  height: 47px;
  line-height: 1;
  padding: 8px;
  position: relative;
  user-select: none;
  width: 100%;
  z-index: 10;
  & .item {
    justify-content: center;
    cursor: pointer;
    & img {
      height: 26px;
      opacity: .4;
      &.selected {
        opacity: 1;
      }
    }
  }
}
</style>
